var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: "dark",
        content: _vm.isFullscreen
          ? _vm.$t("common.outFullScreen")
          : _vm.$t("common.fullScreen"),
        placement: "top",
      },
    },
    [
      _c("el-link", {
        attrs: {
          icon:
            "icon-ym " +
            (_vm.isFullscreen
              ? "icon-ym-compress-screen1"
              : "icon-ym-full-screen1") +
            " Weforsys-common-head-icon",
          underline: false,
        },
        on: {
          click: function ($event) {
            return _vm.click()
          },
        },
      }),
      _c(
        "el-tooltip",
        {
          attrs: {
            effect: "dark",
            content: _vm.isFullscreen
              ? _vm.$t("common.outFullScreen")
              : _vm.$t("common.fullScreen"),
            placement: "top",
          },
        },
        [
          _c("el-link", {
            attrs: {
              icon:
                "icon-ym " +
                (_vm.isFullscreen
                  ? "icon-ym-compress-screen1"
                  : "icon-ym-full-screen1") +
                " Weforsys-common-head-icon",
              underline: false,
            },
            on: {
              click: function ($event) {
                return _vm.click()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }